import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../../security/authentication/authentication.service';
import { UserIdentity } from '../../security/types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    constructor(
        private router: Router,
        private authService: AuthenticationService,
    ) {
    }

    goToDashboardPage() {
        this.router.navigate(['/user/dashboard/tasks']);
    }

    goToSigninPage() {
        this.router.navigateByUrl('login');
    }

    goToChooseOrganizationPage() {
        this.router.navigateByUrl('login/choose-organization');
    }

    goToSetPasswordPage() {
        this.router.navigateByUrl('login/change-password');
    }

    isLoginPageRoute(route: ActivatedRouteSnapshot) {
        return this.checkRoutePageKey(route, 'login');
    }

    isChooseOrganizationRoute(route: ActivatedRouteSnapshot) {
        return this.checkRoutePageKey(route, 'choose-organization');
    }

    isChangePasswordRoute(route: ActivatedRouteSnapshot) {
        return this.checkRoutePageKey(route, 'change-password');
    }

    private checkRoutePageKey(route: ActivatedRouteSnapshot, pageKey: string) {
        return route.children &&
            route.children[0] &&
            route.children[0].data &&
            route.children[0].data.pageKey === pageKey;
    }

    async goToAppropriateSecurityPageOrDashboard() {
        if (this.authService.isUserAuthenticated) {
            let user = this.authService.getUser();
            if (user instanceof Observable) {
                user = await user.toPromise();
            }

            if (user.forcePasswordChange) {
                this.goToSetPasswordPage();
            } else if (!user.activeOrganizationId) {
                this.goToChooseOrganizationPage();
            } else {
                this.goToDashboardPage();
            }
        } else {
            this.goToSigninPage();
        }
    }

    goToZCoreSigninPage() {
        window.location.href = '/';
    }
}
